export enum BLOCK_END_TYPE {
    single = 'single',
    all = 'all',
};

export enum FACTOR_EFFECTIVE_TYPE {
    fix = 'fix',
    percentage = 'percentage',
    calc = 'calc',
    calc_multiply = 'calc_multiply',
    var = 'var',
};